// A coach's request for an injected turn, under the timeline it would add to:
// only when the policy allows it and the share is a byj session. It asks the
// agent for work, through the owner; what people say to each other is the
// side panel's chat (byj-1wv.51.3).
import { useState, type FormEvent } from "react";
import { t, word } from "../i18n";
import type { InjectionItem } from "../timeline";

export function Composer({
  injections,
  disabled,
  onInject,
}: {
  injections: InjectionItem[];
  disabled: boolean;
  onInject: (text: string) => boolean;
}) {
  const [inject, setInject] = useState("");
  const last = injections[injections.length - 1];
  const waiting = last !== undefined && last.outcome === undefined;

  const submitInject = (e: FormEvent) => {
    e.preventDefault();
    const text = inject.trim();
    if (text && !waiting && onInject(text)) setInject("");
  };

  return (
    <div className="composer">
      <form onSubmit={submitInject} className="composer-card inject" data-testid="inject-form" aria-label={t("session:injectTitle")}>
        <div className="composer-card-head">
          <strong>{t("session:injectTitle")}</strong>
          <span className="muted small">{t("session:injectWho")}</span>
        </div>
        <div className="composer-row">
          <input
            aria-label={t("session:injectPlaceholder")}
            placeholder={t("session:injectPlaceholder")}
            value={inject}
            onChange={(e) => setInject(e.target.value)}
            disabled={disabled || waiting}
          />
          <button type="submit" className="primary" disabled={disabled || waiting || !inject.trim()}>
            {t("session:sendInject")}
          </button>
        </div>
      </form>
      {last && (
        <p className={`inject-state ${last.outcome ? `outcome-${last.outcome}` : "waiting"}`} role="status">
          {last.outcome ? word("session:injectOutcome", last.outcome) : t("session:injectWaiting")}
          {last.reason ? ` (${last.reason})` : ""}
        </p>
      )}
    </div>
  );
}
